import React, { useEffect, useState } from "react";
import { Link, Route, Routes, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Slider from "react-slick";
import { UserSidebar } from "./UserSidebar";
import { Header } from "Views/Private/Admin/ApplicationStatus/Header";
import { Overview } from "Views/Private/Admin/ApplicationStatus/Overview";
import { Chat } from "Views/Private/Admin/ApplicationStatus/Chat";
import { Email } from "Views/Private/Admin/ApplicationStatus/Email";
import { Logs } from "Views/Private/Admin/ApplicationStatus/Logs";
import { Timeline } from "Views/Private/Admin/ApplicationStatus/Timeline";
import { Document } from "Views/Private/Admin/ApplicationStatus/Document";
import { authService } from "Service/Axios";
import { PROJECT_APPLICANTS_SNAPSHOT_URL } from "Constant/api";
import { paths } from "Constant/paths";
import { useQueryParams } from "Utils/hooks";

const settings = {
  infinite: false,
  dots: false,
  arrows: true,
  variableWidth: true,
  focusOnSelect: false,
  speed: 500,
  slidesToShow: 8,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
      },
    },
    // {
    //   breakpoint: 600,
    //   settings: {
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //   },
    // },
    // {
    //   breakpoint: 480,
    //   settings: {
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //   },
    // },
  ],
};

export default function ApplicationStatus() {
  const { t } = useTranslation();
  const { gid } = useParams();
  const { pathname } = useLocation();
  const { projectId, stageId } = useQueryParams();

  const [applicantsSnapshotList, setApplicantsSnapshotList] = useState([]);

  const {
    admin: {
      applicationStatus: {
        root,
        overview,
        chat,
        email,
        logs,
        timeline,
        document,
      },
    },
  } = paths;

  // Listing
  const getApplicationSnapshots = async () => {
    try {
      if (projectId && stageId) {
        const data = {
          projectId,
          stageId,
        };
        const response = await authService(
          PROJECT_APPLICANTS_SNAPSHOT_URL,
          "POST",
          data
        );
        setApplicantsSnapshotList(response.data);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    getApplicationSnapshots();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <main className="main">
        <div className="application-box d-sm-flex">
          {projectId && stageId && (
            <UserSidebar
              userGid={gid}
              projectId={projectId}
              stageId={stageId}
              userList={applicantsSnapshotList}
            />
          )}
          <div className="applicant-status-bar rounded-2 bg-grey-100 w-100">
            <Header gid={gid} />
            <div className="slide-status-nav position-relative bg-grey-50 position-sticky top-0 z-1">
              {/* <button
                onClick={() => navigate(-1)}
                className="btn btn-transparent border-0 back-right-position position-absolute top-0 start-0 bottom-0 d-flex align-items-center"
              >
                <i className="bx bx-arrow-back bx-sm"></i>
              </button> */}
              <Slider {...settings}>
                <div
                  className={`nav-status-item ${
                    pathname.includes(overview) ? "active" : ""
                  }`}
                >
                  <Link
                    to={
                      projectId && stageId
                        ? `${root}/${gid}${overview}?projectId=${projectId}&stageId=${stageId}`
                        : `${root}/${gid}${overview}`
                    }
                  >
                    {t("common.button.overview")}
                  </Link>
                </div>
                <div
                  className={`nav-status-item ${
                    pathname.includes(chat) ? "active" : ""
                  }`}
                >
                  <Link
                    to={
                      projectId && stageId
                        ? `${root}/${gid}${chat}?projectId=${projectId}&stageId=${stageId}`
                        : `${root}/${gid}${chat}`
                    }
                  >
                    {t("common.button.chat")}
                  </Link>
                </div>
                <div
                  className={`nav-status-item ${
                    pathname.includes(email) ? "active" : ""
                  }`}
                >
                  <Link
                    to={
                      projectId && stageId
                        ? `${root}/${gid}${email}?projectId=${projectId}&stageId=${stageId}`
                        : `${root}/${gid}${email}`
                    }
                  >
                    {t("common.button.email")}
                  </Link>
                </div>
                <div
                  className={`nav-status-item ${
                    pathname.includes(logs) ? "active" : ""
                  }`}
                >
                  <Link
                    to={
                      projectId && stageId
                        ? `${root}/${gid}${logs}?projectId=${projectId}&stageId=${stageId}`
                        : `${root}/${gid}${logs}`
                    }
                  >
                    {t("common.button.logs")}
                  </Link>
                </div>
                <div
                  className={`nav-status-item ${
                    pathname.includes(timeline) ? "active" : ""
                  }`}
                >
                  <Link
                    to={
                      projectId && stageId
                        ? `${root}/${gid}${timeline}?projectId=${projectId}&stageId=${stageId}`
                        : `${root}/${gid}${timeline}?`
                    }
                  >
                    {t("common.button.timeline")}
                  </Link>
                </div>
                <div
                  className={`nav-status-item ${
                    pathname.includes(document) ? "active" : ""
                  }`}
                >
                  <Link
                    to={
                      projectId && stageId
                        ? `${root}/${gid}${document}?projectId=${projectId}&stageId=${stageId}`
                        : `${root}/${gid}${document}?`
                    }
                  >
                    {t("Document")}
                  </Link>
                </div>
              </Slider>
            </div>

            <div className="sub-slide">
              <Routes>
                <Route
                  path={overview}
                  element={<Overview projectId={projectId} gid={gid} />}
                />
                <Route path={chat} element={<Chat gid={gid} />} />
                <Route path={email} element={<Email gid={gid} />} />
                <Route path={logs} element={<Logs gid={gid} />} />
                <Route path={timeline} element={<Timeline gid={gid} />} />
                <Route path={document} element={<Document gid={gid} />} />
              </Routes>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
